import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  select: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '0.5rem',
    cursor: 'pointer',
    fontSize: theme.size.sm,

    '& .icon': {
      marginRight: '0.5rem',
      fontSize: theme.size.base
    }
  },

  user: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '0.25rem',
    fontSize: theme.size.sm,

    '& .close': {
      marginLeft: '0.5rem',
      fontSize: theme.size.sm,
      cursor: 'pointer'
    }
  },

  anchor: {
    width: 'fit-content'
  },

  border: {
    display: 'flex',
    alignItems: 'center',
    border: `1px solid ${theme.border.outline}`,
    borderRadius: '5px',
    boxSizing: 'border-box',
    padding: '0.25rem'
  }
}))

export default useStyles
